import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import { type ListingAddon } from 'src/common/types/common/Addons';
import { formatAddonPrice } from 'src/addons/utils/helpers';
import styles from './AddonCostPanel.module.scss';

export type AddonCostPanelProps = {
  addons: ListingAddon[];
  /** All addon.optional or all addon.payment_due == 3 */
  type: 'optional' | 'later';
};

const AddonCostPanel: FC<AddonCostPanelProps> = ({
  addons,
  type,
}) => {
  const [t] = useTranslation('common');

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Typography
          size="body-l"
          weight="semibold"
          type="h3"
        >
          {type === 'optional' ? t('addons--optional-title') : t('addons--later-title')}
        </Typography>
        <Typography
          size="caption"
          type="p"
        >
          {type === 'optional' ? t('addons--optional-description') : t('addons--later-description')}
        </Typography>
      </div>
      {addons.map((addon) => {
        const { amount, type: unit } = formatAddonPrice(addon, t);
        return (
          <div key={addon.id} className={styles.row}>
            <div className={styles.title}>
              <Typography
                size="body-m"
                type="p"
              >
                {addon.title}
              </Typography>
              {type === 'later' && (
                <div className={styles.estimated}>
                  <Typography
                    size="body-s"
                    type="p"
                  >
                    (
                    {t('addons--later-estimated')}
                    )
                  </Typography>
                </div>
              )}
            </div>
            <div className={styles.price}>
              <Typography
                size="body-m"
                type="p"
              >
                {amount}
              </Typography>
              <Typography
                size="caption"
                type="p"
              >
                {unit}
              </Typography>
            </div>

          </div>
        );
      })}
    </div>
  );
};

export default AddonCostPanel;
